export default __webpack_public_path__ + "./fonts/play-light.64f356a49921fbfe7fd3e149236f541b.svg";